import FreeQuote from "../components/home/FreeQuote";

const TRANSLATIONS = {
  HOME: {
    META: {
      ro: "Servicii web complete, de la web design pana la aplicatii web, aplicatii mobile, site-uri web si gazduire software.",
      en: "Full Suite Software Services, from web design to web and mobile applications, websites and hosting."
    },
    KEYWORDS: {
      ro: "site-uri la comanda, servicii web, implementare site, implementare aplicatii, dezvoltare software, web design, implementare software",
      en: "custom websites, web services, site implementation, application implementation, software development, web design, software implementation"
    },
    NAV: {
      item_links_1: {
        ro: "Servicii",
        en: "Services",
      },
      item_links_2: {
        ro: "Despre noi",
        en: "About",
      },
      item_links_3: {
        ro: "Ofertă gratuită",
        en: "Free quote",
      },
      menu: {
        ro: "MENIU",
        en: "MENU",
      },
      close: {
        ro: "ÎNCHIDE",
        en: "CLOSE",
      },
    },
    HEADER: {
      weBuild: {
        ro: "Construim Software",
        en: "We build software",
      },
      header_1: {
        ro: "Strategie. Site-uri. Produse.",
        en: "Strategy. Sites. Products.",
      },
      header_2: {
        1: { ro: "Proiectare ", en: "Designed " },
        2: { ro: "ȘI", en: "AND" },
        3: { ro: " dezvoltare corespunzătoare.", en: " developed properly." },
      },
      description: {
        en: "Having a website that represents you or a product that is developed with care and attention to details shouldn’t be a hassle.",
        ro: "A avea un site web care te reprezintă pe tine sau un produs dezvoltat cu grijă și atenție la detalii nu ar trebui să fie o bătaie de cap.",
      },
      getQuote: {
        ro: "Obține ofertă gratuită",
        en: "Get a free quote",
      },
    },

    SERVICES: {
      'ourServices': {
        'ro': 'SERVICIILE NOASTRE',
        'en': 'OUR SERVICES',
      },
      'header_1': {
        'ro': 'Lucrurile la care suntem buni.',
        'en': 'The things we’re good at.',
      },
      'p_1': {
        'ro': 'De peste 15 ani, suntem profund implicați în această muncă. Experiența noastră cuprinde colaborări cu unele dintre cele mai mari companii din lume, precum și sprijinirea afacerilor aflate la început de drum, startup-urilor și firmelor deja consacrate. Pe scurt, înțelegem cum funcționează lucrurile și cum să ducem treaba la bun sfârșit.',
        'en': 'For the past 15 years, we’ve been immersed in this work. Our experience spans collaborations with some of the world’s largest companies, as well as supporting pre-seed ventures, startups, and established businesses. Simply put, we understand how things work and how to get the job done.'
      },
      'servicesOverview': {
        'ro': 'PREZENTAREA GENERALĂ A SERVICIILOR',
        'en': 'SERVICES OVERVIEW',
      },
      'firstList_1': {
        'ro': 'AUDIT WEBSITE ȘI PRODUS',
        'en': 'WEBSITE & PRODUCT AUDIT',
      },
      'firstList_2': {
        'ro': 'SPRINTURI DE DESIGN',
        'en': 'DESIGN SPRINTS',
      },
      'firstList_3': {
        'ro': 'PROTOTIPURI',
        'en': 'PROTOTYPES',
      },
      'firstList_4': {
        'ro': 'DEZVOLTARE MVP',
        'en': 'MVP DEVELOPMENT',
      },
      'firstList_5': {
        'ro': 'ACTUALIZARE WEBSITE ȘI PRODUS',
        'en': 'WEBSITE & PRODUCT REFRESH',
      },
      'firstList_6': {
        'ro': 'ÎMBUNĂTĂȚIRI WEBSITE ȘI PRODUS',
        'en': 'WEBSITE & PRODUCT ENHANCEMENTS',
      },
      'firstList_7': {
        'ro': 'AUTOMATIZAREA PROCESELOR',
        'en': 'PROCESS AUTOMATION',
      },
      'firstList_8': {
        'ro': 'DESIGN ȘI DEZVOLTARE PERSONALIZATĂ',
        'en': 'CUSTOM DESIGN & DEVELOPMENT',
      },
      'techStack': {
        'ro': 'TEHNOLOGII UTILIZATE',
        'en': 'TECH STACK',
      },
      'header_2': {
        'ro': 'Dezvoltare aplicații web de la început până la sfârșit',
        'en': 'End-to-end web applications development',
      },
      'p_2': {
        'ro': 'Construim aplicații web scalabile, sigure și performante, care rezolvă probleme reale. De la concept la implementare, lucrăm împreună cu tine pentru a crea software intuitiv, fiabil și pregătit pentru viitor.',
        'en': 'Building scalable, secure, and high-performing web applications that solve real-world problems. From concept to deployment, we partner with you to create software that’s intuitive, reliable, and future-ready.',
      },
      'features1': {
        'ro': 'CARACTERISTICI',
        'en': 'FEATURES',
      },
      'features1List_1': {
        'ro': 'DESIGN WEBSITE PERSONALIZAT',
        'en': 'CUSTOM WEBSITE DESIGN',
      },
      'features1List_2': {
        'ro': 'DEZVOLTARE RESPONSIVĂ',
        'en': 'RESPONSIVE DEVELOPMENT',
      },
      'features1List_3': {
        'ro': 'SOLUȚII E-COMERCIALE',
        'en': 'E-COMMERCE SOLUTIONS',
      },
      'header_3': {
        'ro': 'Design și dezvoltare website',
        'en': 'Website design and development',
      },
      'p_3': {
        'ro': 'Creăm website-uri vizual impresionante și ușor de utilizat, care reprezintă brandul tău și generează rezultate. De la portofolii elegante la platforme e-commerce robuste, soluțiile noastre sunt personalizate pentru a atinge obiectivele tale.',
        'en': 'We create visually striking, user-friendly websites that represent your brand and deliver results. From sleek portfolios to robust e-commerce platforms, our solutions are tailored to achieve your goals.',
      },
      'features2List_1': {
        'ro': 'DEZVOLTARE APLICATII WEB PERSONALIZATE',
        'en': 'CUSTOM WEB APPLICATION DEVELOPMENT',
      },
      'features2List_2': {
        'ro': 'APLICAȚII WEB PROGRESIVE',
        'en': 'PROGRESSIVE WEB APPS',
      },
      'features2List_3': {
        'ro': 'INTEGRARE API',
        'en': 'API INTEGRATION',
      },
      'features2List_4': {
        'ro': 'OPTIMIZARE PERFORMANȚĂ',
        'en': 'PERFORMANCE OPTIMIZATION',
      },
      'header_4': {
        'ro': 'Găzduire și întreținere',
        'en': 'Hosting and maintanance',
      },
      'p_4': {
        'ro': 'Serviciile noastre de găzduire și întreținere asigură faptul că prezența ta digitală rămâne fără întreruperi și fără bătăi de cap. De la planificare strategică la suport practic, vom menține website-ul și aplicațiile tale optimizate, sigure și funcționând perfect.',
        'en': 'Our hosting and maintenance services ensure your digital presence remains seamless and hassle-free. From strategic planning to hands-on support, we’ll keep your website and applications optimized, secure, and running smoothly.',
      },
      'features3List_1': {
        'ro': 'AUDIT TEHNOLOGIC ȘI RECOMANDĂRI',
        'en': 'TECHNOLOGY AUDIT & RECOMMENDATIONS',
      },
      'features3List_2': {
        'ro': 'OPTIMIZARE UX/UI',
        'en': 'UX/UI OPTIMIZATION',
      },
      'features3List_3': {
        'ro': 'CONSULTANȚĂ PENTRU SCALABILITATE ȘI SECURITATE',
        'en': 'SCALABILITY & SECURITI CONSULTING',
      },
    },
    WHYUS: {
      whyUs: {
        ro: "De ce noi",
        en: "Why us",
      },
      header_1: {
        ro: "Ne mândrim cu ceea ce oferim.",
        en: "We take pride in what we deliver.",
      },
      header_2: {
        ro: "Suntem o echipă de experți pasionați de web, dedicați livrării unor experiențe digitale excepționale.",
        en: "We're a team of passionate web experts dedicated to delivering exceptional digital experiences.",
      },
      feature: {
        header: {
          1: {
            ro: "Noi ne ocupăm de detalii",
            en: "We sweat the details",
          },
          2: {
            ro: "Soluții personalizate",
            en: "Tailored Solutions",
          },
          3: {
            ro: "Echipă experimentată",
            en: "Experienced Team",
          },
          4: {
            ro: "Abordare centrată pe client",
            en: "Client-Centric Approach",
          },
        },
        content: {
          1: {
            ro: "MULTE STUDIOURI DE DEZVOLTARE POT CREA O SOLUȚIE, DAR DOAR CÂTEVA SE PREOCUPĂ DE FIECARE DETALIU. NOI SUNTEM UNUL DINTRE ACELEA.",
            en: "A LOT OF DEVELOPMENT STUDIOS CAN DEVELOP A SOLUTION, BUT A HANDFUL CARE ABOUT EVERY DETAIL. WE'RE THOSE ONES.",
          },
          2: {
            ro: "NICIO ABORDARE UNIVERSALĂ AICI. FIECARE PROIECT ESTE CREAT PERSONALIZAT PENTRU A SE POTRIVI NEVOILOR TALE UNICE.",
            en: "NO ONE-SIZE-FITS-ALL APPROACHES HERE. EVERY PROJECT IS CUSTOM-BUILT TO MEET YOUR UNIQUE NEEDS.",
          },
          3: {
            ro: "CU PESTE 15 ANI DE EXPERIENȚĂ ÎN INDUSTRIE ȘI UN ISTORIC DOVEDIT, ADUCEM EXPERTIZĂ ÎN CARE POȚI AVEA ÎNCREDERE.",
            en: "WITH MORE THAN 15 YEARS OF EXPERIENCE IN THE BUSINESS AND A PROVEN TRACK RECORD, WE BRING EXPERTISE YOU CAN TRUST.",
          },
          4: {
            ro: "SUCCESUL TĂU ESTE SUCCESUL NOSTRU. COLABORARE ȘI COMUNICARE DESCHISĂ LA FIECARE PAS.",
            en: "YOUR SUCCESS IS OUR SUCCESS. COLLABORATION AND OPEN COMMUNICATION AT EVERY STEP.",
          },
        },
      },
      box_header: {
        ro: "Destul text",
        en: "ENOUGH TEXT",
      },
      box_content: {
        ro: "Gata să începem?",
        en: "Ready to get things going?",
      },
    },

    FREEQUOTE: {
      'header_1': {
        'ro': 'Obține o ofertă gratuită pentru proiectul tău',
        'en': 'Get a free quote for your project',
      },
      'p_1': {
        'ro': 'Spune-ne câteva detalii despre proiectul tău și îți vom trimite un email care va conține o listă cu lucrurile pe care le considerăm că vei avea nevoie și costurile asociate acestora.',
        'en': 'Tell us a few things about your project and we’ll send you an email containing a list of things that we think you’ll need and the associated costs for them.',
      },
      'p_2': {
        'ro': 'Nu te vom deranja cu spam și nu vom reveni cu un follow-up, doar dacă îți dorești acest lucru.',
        'en': 'We won’t spam you nor follow up, unless you want us to.',
      },
      'formYourName': {
        'ro': 'NUMELE TAU',
        'en': 'YOUR NAME',
      },
      'formYourNamePlaceholder': {
        'ro': 'Este plăcut să știm cu cine vorbim',
        'en': "It's nice to know who we're talking to",
      },
      'formCompanyName': {
        'ro': 'NUMELE COMPANIEI / WEBSITE',
        'en': 'COMPANY NAME / WEBSITE',
      },
      'formCompanyNamePlaceholder': {
        'ro': 'Acme.ro',
        'en': "Acme.co",
      },
      'formYourEmail': {
        'ro': 'ADRESA TA DE EMAIL',
        'en': 'YOUR EMAIL',
      },
      'formYourEmailPlaceholder': {
        'ro': 'Spune-ne unde te putem contacta',
        'en': "Let us know where we can reach you",
      },
      'formProjectType': {
        'ro': 'TIPUL PROIECTULUI',
        'en': 'PROJECT TYPE',
      },
      'formProjectType_1': {
        'ro': 'Selectează o opțiune',
        'en': 'Select an option',
      },
      'formProjectType_2': {
        'ro': 'Website',
        'en': 'Website',
      },
      'formProjectType_3': {
        'ro': 'Aplicație web',
        'en': 'Web Application',
      },
      'formProjectType_4': {
        'ro': 'Aplicație mobilă',
        'en': 'Mobile Application',
      },
      'formProjectType_5': {
        'ro': 'Lucrări de design',
        'en': 'Design Work',
      },
      'formProjectType_6': {
        'ro': 'Lucrări de dezvoltare',
        'en': 'Development Work',
      },
      'formProjectType_7': {
        'ro': 'Consultanță',
        'en': 'Consultancy',
      },
      'formProjectType_8': {
        'ro': 'Altele',
        'en': 'Other',
      },
      'formDescription': {
        'ro': 'DESCRIEREA PROIECTULUI',
        'en': 'DESCRIBE WHAT YOU NEED',
      },
      'formDescriptionPlaceholder': {
        'ro': 'Cu cât ne oferi mai multe detalii, cu atât oferta va fi mai precisă',
        'en': 'The more details we have the better the quote',
      },
      'formSubmit': {
        'ro': 'Trimite',
        'en': 'Submit',
      },
      'formSubmitSucces': {
        'ro': 'Formularul tău a fost trimis',
        'en': 'Your form has been sent',
      },
      'formSubmitError': {
        'ro': 'A apărut o eroare. Te rugăm să încerci din nou.',
        'en': 'An error occurred. Please try again',
      },

    },
    FAQ: {
      askQuestion: {
        ro: "Întrebări?",
        en: "Questions?",
      },
      header_1: {
        ro: "Câteva întrebări frecvente",
        en: "Some frequently asked questions",
      },
      header_2: {
        ro: "Când vine vorba de lucrurile cu care te putem ajuta și modul în care lucrăm, am răspuns la câteva întrebări frecvente.",
        en: "When it comes to the things that we can help with and how we work, we've answered some frequent questions.",
      },
      questions: {
        1: {
          question: {
            ro: "Cu ce industrii lucrați?",
            en: "What industries do you work with?",
          },
          answer: {
            ro: "Lucrăm cu o gamă largă de industrii, inclusiv e-commerce, sănătate, educație, tehnologie, finanțe și altele. Soluțiile noastre sunt personalizate pentru a satisface nevoile unice ale fiecărui sector.",
            en: "We work with a wide range of industries, including e-commerce, healthcare, education, technology, finance, and more. Our solutions are tailored to meet the unique needs of each sector.",
          },
        },
        2: {
          question: {
            ro: "Cât durează finalizarea unui proiect?",
            en: "How long does it take to complete a project?",
          },
          answer: {
            ro: "Durata variază în funcție de complexitatea și amploarea proiectului. Un proiect tipic dewebsite poate dura între 4-8 săptămâni, iar aplicațiile web pot necesita mai mult timp. Vom furniza un calendar detaliat în faza de planificare.",
            en: "Timelines vary depending on the project's complexity and scope. A typical website project can take 4-8 weeks, while web applications may take longer. We'll provide a detailed timeline during the planning phase.",
          },
        },
        3: {
          question: {
            ro: "Ne puteți ajuta cu întreținerea continuă a site-ului web?",
            en: "Can you help with ongoing website maintenance?",
          },
          answer: {
            ro: "Absolut! Oferim pachete de mentenanță și suport pentru a ne asigura că site-ul sau aplicația ta rămâne actualizată, securizată și optimizată.",
            en: "Absolutely! We offer maintenance and support packages to ensure your website or application remains updated, secure, and optimized.",
          },
        },
        4: {
          question: {
            ro: "Oferiți soluții personalizate?",
            en: "Do you offer custom solutions?",
          },
          answer: {
            ro: "Da, toate serviciile noastre sunt complet personalizabile. Lucrăm îndeaproape cu tine pentru a înțelege obiectivele tale și pentru a crea soluții care se aliniază viziunii tale.",
            en: "Yes, all our services are fully customizable. We work closely with you to understand your goals and create solutions that align with your vision.",
          },
        },
        5: {
          question: {
            ro: "Ce tehnologii folosiți?",
            en: "What technologies do you use?",
          },
          answer: {
            ro: "Suntem specializați într-o varietate de tehnologii, inclusiv HTML, CSS, JavaScript, React, Angular, Node.js, Python și multe altele. Alegem cele mai potrivite instrumente în funcție de cerințele proiectului tău.",
            en: "We specialize in a variety of technologies, including HTML, CSS, JavaScript, React, Angular, Node.js, Python, and more. We select best tools based on your's project requirements.",
          },
        },
        6: {
          question: {
            ro: "Cum începem?",
            en: "How do we get started?",
          },
          answer: {
            ro: "Pur și simplu, contactează-ne prin formularul nostru de contact sau sună-ne. Vom discuta despre nevoile tale, îți vom oferi o propunere și vom începe să creăm soluția ta digitală.",
            en: "Simply reach out via our contract form or give us a call. We'll discuss your needs, provide a proposal, and begin crafting your digital solution.",
          },
        },
      },
    },
  },
  ARTICLE: {
    HEADER: {
      "loading": {
        en: 'Loading article...',
        ro: 'Se incarca articolul...'
      },
      "notFound": {
        en: 'Article not found',
        ro: 'Articolul nu a fost gasit'
      }
    }
  },
  BLOG: {
    meta: {
      en: 'Read our latest articles on various topics like software development and web applications.',
      ro: 'Citește ultimele articole pe diverse teme precum dezvoltarea de software și aplicații web.'
    },
    content: {
      'title': {
        ro: 'Articole recente',
        en: 'Recent articles',
      }
    }
  },
  FOOTER: {
    'copy': {
      en: 'COPYRIGHT 2025 © AZA SOFTWARE. ALL RIGHTS RESERVED.',
      ro: 'COPYRIGHT 2025 © AZA SOFTWARE. TOATE DREPTURILE REZERVATE.'
    }
  }
};

const translateString = (path, language = "en") => {
  const translationSteps = path.split(".");
  let listOfUnprocessedTranslationSteps = JSON.parse(
    JSON.stringify(TRANSLATIONS)
  );

  while (translationSteps.length) {
    /// HOME, HEADER, webuild
    const currentStep = translationSteps.shift();

    listOfUnprocessedTranslationSteps =
      listOfUnprocessedTranslationSteps[currentStep];
  }

  const ResultingTranslation =
    listOfUnprocessedTranslationSteps[language] ||
    listOfUnprocessedTranslationSteps["en"];

  // debugger;
  if (typeof ResultingTranslation != "string") {
    return ResultingTranslation();
  } else return ResultingTranslation;
};

// console.log(translateString('HOME.HEADER.weBuild', 'ro')); // Output: Construim Software
// console.log(translateString('HOME.HEADER.weBuild', 'hu')); // Output: Construim Software

export { translateString, TRANSLATIONS };
